import { SessionRunsProvider } from "../../../contexts/sessionRunsContext";
import { AuditWorkpaperViewPageV2 } from "./AuditWorkPaperViewV2";

export const AuditWorkpaperViewPageV2WithProvider = () => {
  return (
    <SessionRunsProvider>
      <AuditWorkpaperViewPageV2 />
    </SessionRunsProvider>
  );
};
